(() => {
  class SctTabs {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('.sct__tab'));
      this.panels = Array.from(root.querySelectorAll('.sct__panel'));
      if (!this.tabs.length || !this.panels.length) return;

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.tl = false;
      if (this.animations_enabled) {
        this.tl = gsap.timeline({ paused: true });
      }

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.tabs.forEach(tab => tab.addEventListener('click', this.onClick));
      root.addEventListener('keydown', this.onKeydown);
    }

    activateTab(tab) {
      const targetId = tab.getAttribute('data-target');
      const target = this.root.querySelector('#' + CSS.escape(targetId));
      if (!target) return;

      this.tabs.forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.removeAttribute('tabindex');

      this.panels.forEach(p => (p.hidden = true));
      target.hidden = false;

      if (this.animations_enabled) {
        this.animateProducts(target);
      }

      tab.focus();
    }

    onClick(e) {
      const tab = e.currentTarget;
      this.activateTab(tab);
    }

    onKeydown(e) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(e.key)) return;

      const current = this.root.querySelector('.sct__tab.is-active') || this.tabs[0];
      const idx = this.tabs.indexOf(current);
      let nextIdx = idx;

      if (e.key === 'ArrowRight') nextIdx = (idx + 1) % this.tabs.length;
      if (e.key === 'ArrowLeft') nextIdx = (idx - 1 + this.tabs.length) % this.tabs.length;
      if (e.key === 'Home') nextIdx = 0;
      if (e.key === 'End') nextIdx = this.tabs.length - 1;

      e.preventDefault();
      this.activateTab(this.tabs[nextIdx]);
    }

    animateProducts(panel) {
      const products = panel.querySelectorAll('.sct-card');
      if (!products.length) return;

      gsap.killTweensOf(products);
      gsap.set(products, {
        opacity: 0,
        y: 30
      });

      this.tl
        .clear()
        .to(products, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: {
            amount: 0.3,
            from: 'start'
          }
        });

      this.tl.play();
    }
  }

  function initAll(context = document) {
    const sections = context.querySelectorAll('[data-section-type="sct-tabs-grid"]');
    sections.forEach(sec => {
      if (sec.__sctInit) return;
      sec.__sctInit = new SctTabs(sec);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:reorder', () => {
    initAll(document);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const btn = e.target?.querySelector?.('.sct__tab');
    if (btn) btn.focus();
  });
})();
